<template>
    <svg
        id="copy"
        xmlns="http://www.w3.org/2000/svg"
        width="21.313"
        height="25.592"
        viewBox="0 0 21.313 25.592"
    >
        <path
            id="Pfad_492"
            data-name="Pfad 492"
            d="M4.814,2.907v1.61H2.568v0a2.425,2.425,0,0,0-1.815.854A3.1,3.1,0,0,0,0,7.421H0V22.686H0A3.109,3.109,0,0,0,.758,24.74a2.425,2.425,0,0,0,1.808.848v0H13.93v0a2.428,2.428,0,0,0,1.815-.854,3.1,3.1,0,0,0,.749-2.045h0V19.267h2.246v0a2.428,2.428,0,0,0,1.815-.854,3.1,3.1,0,0,0,.749-2.045h0V2.905h0A3.111,3.111,0,0,0,20.554.852,2.425,2.425,0,0,0,18.746,0V0H7.382V0A2.425,2.425,0,0,0,5.567.858,3.1,3.1,0,0,0,4.818,2.9h0v0Zm1.948,1.61V2.9h0a.748.748,0,0,1,.186-.494A.589.589,0,0,1,7.38,2.2v0H18.744v0a.587.587,0,0,1,.436.21.751.751,0,0,1,.184.494h0V16.364h0a.748.748,0,0,1-.186.494.589.589,0,0,1-.436.208v0H16.5V7.423h0a3.11,3.11,0,0,0-.755-2.054,2.425,2.425,0,0,0-1.808-.848v0H6.762ZM1.95,22.684V7.421h0a.748.748,0,0,1,.186-.494.589.589,0,0,1,.436-.208v0H13.932v0a.587.587,0,0,1,.436.21.751.751,0,0,1,.184.494h0V22.689h0a.748.748,0,0,1-.186.494.589.589,0,0,1-.436.208v0H2.566v0a.587.587,0,0,1-.436-.21.751.751,0,0,1-.184-.494h0v0Z"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "CopyIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
